// Updated version legal language
export const defaultLegalNotice = `Files contain certain proprietary methods, formulas, processes, techniques, and 
       background technologies (collectively, “Material”) developed by Merck & Co., Inc. In accordance with Company policies, 
       additional approvals for authorized disclosure or transfer outside of Merck & Co., Inc. may be required. 
       Use and modifications according to CORE SOP-13 Model Adaptation Guides are permitted.`;
